// extracted by extract-css-chunks-webpack-plugin
module.exports = {"wrapper":"BusinessPage-4ff42e477e0e5c8f"};